/** Content hash of the SVG sprites (generated by build-icon-sprites.ts), busts the year-long asset cache */
export const ICON_SPRITE_VERSION = '10eeedc7';
